import { Link } from "react-router";

export const Footer = ({ interestForm }) => {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="flex max-w-dvw border-t border-gray-200 bg-darkgreen-400 px-4 pt-8 pb-6 text-white md:px-6 md:pt-16">
            <div className="container mx-auto flex flex-col text-sm">
                <div className="mb-6 grid grid-cols-12 gap-x-8 gap-y-6 lg:gap-x-0">
                    <div className="col-span-full md:col-span-4">
                        <Link to="/">
                            <img
                                alt="WELNIDO Logo"
                                src="/logo-beige.svg"
                                height="80"
                                width="140"
                                fetchPriority="high"
                            />
                        </Link>
                        <p className="mt-4 w-3/4 text-sm text-white/70">
                            Putting trusted professionals within easy reach.
                            Where clarity meets care.
                        </p>
                    </div>
                    {!interestForm && (
                        <>
                            <div className="col-span-6 flex flex-col space-y-4 md:col-span-2">
                                <p className="font-bold uppercase">Patients</p>
                                <Link
                                    to="/clinicians/find"
                                    className="text-white/70 hover:text-emerald-950"
                                >
                                    Find a clinician
                                </Link>
                                <Link
                                    to="/how-it-works"
                                    className="text-white/70 hover:text-emerald-950"
                                >
                                    How it works
                                </Link>
                                <Link
                                    to="/specialties"
                                    className="text-white/70 hover:text-emerald-950"
                                >
                                    Specialties
                                </Link>
                            </div>

                            <div className="col-span-6 flex flex-col space-y-4 md:col-span-2">
                                <p className="font-bold uppercase">
                                    Clinicians
                                </p>
                                <Link
                                    to="/register"
                                    className="text-white/70 hover:text-emerald-950"
                                >
                                    List your practice
                                </Link>
                                <Link
                                    to="/pricing"
                                    className="text-white/70 hover:text-emerald-950"
                                >
                                    Pricing
                                </Link>
                            </div>
                        </>
                    )}
                    <div className="col-span-6 flex flex-col space-y-4 md:col-span-2">
                        <p className="font-bold uppercase">Company</p>
                        <Link
                            to="/about"
                            className="text-white/70 hover:text-emerald-950"
                        >
                            About
                        </Link>
                        {!interestForm && (
                            <Link
                                to="/contact"
                                className="text-white/70 hover:text-emerald-950"
                            >
                                Contact
                            </Link>
                        )}
                    </div>

                    <div className="col-span-6 flex flex-col space-y-4 md:col-span-2">
                        <p className="font-bold uppercase">Legal</p>
                        <Link
                            to="/privacy"
                            className="text-white/70 hover:text-emerald-950"
                        >
                            Privacy
                        </Link>
                        {!interestForm && (
                            <>
                                <Link
                                    to="/terms"
                                    className="text-white/70 hover:text-emerald-950"
                                >
                                    Terms
                                </Link>
                                <Link
                                    to="/governance"
                                    className="text-white/70 hover:text-emerald-950"
                                >
                                    Clinical governance
                                </Link>
                            </>
                        )}
                    </div>
                </div>
                <div className="mt-4 flex border-t border-white/25 pt-4 md:mt-6 md:pt-6">
                    <div className="text-xs text-white/60">
                        <span>
                            © {currentYear} Welnido Limited. All rights
                            reserved.
                        </span>
                    </div>
                    <div className="ms-auto text-right text-xs text-white/60">
                        <span>Verified clinicians</span>
                    </div>
                </div>
            </div>
        </footer>
    );
};
